'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import H4 from 'UIComponents/elements/headings/H4';
import UITruncateString from 'UIComponents/text/UITruncateString';
import BreakpointsContainer from 'ContentEditorUI/containers/BreakpointsContainer';
import UndoRedoButtonContainer from 'ContentEditorUI/containers/UndoRedoButtonContainer';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UICloseButton from 'UIComponents/button/UICloseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { connect } from 'react-redux';
import { getShouldUseResponsiveBreakpoints } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  shouldUseResponsiveBreakpoints: getShouldUseResponsiveBreakpoints(state),
  isReadOnlyMode: getIsReadOnlyMode(state),
  isUngatedForPatagonia: getIsUngatedForPatagonia(state)
});
class BaymaxSidebarHeaderContainer extends Component {
  render() {
    const {
      backLink,
      headerLabel,
      showUndoRedoButtons,
      shouldUseResponsiveBreakpoints,
      showDeviceToggle,
      isReadOnlyMode,
      breadcrumbs,
      isUngatedForPatagonia,
      closePatagoniaSidebarCallback
    } = this.props;
    const {
      tour
    } = this.context;
    const headerContainerContents = /*#__PURE__*/_jsxs(Fragment, {
      children: [breadcrumbs, /*#__PURE__*/_jsxs(UIFlex, {
        className: breadcrumbs ? 'sidebar-header-with-breadcrumbs p-x-5' : 'sidebar-header p-x-5',
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/_jsx(UIBox, {
          className: "sidebar-header-label",
          children: /*#__PURE__*/_jsxs(UIFlex, {
            direction: "column",
            align: "start",
            children: [backLink && /*#__PURE__*/_jsxs("div", {
              className: "p-bottom-2",
              children: [/*#__PURE__*/_jsx(UIIcon, {
                name: "left"
              }), " ", backLink]
            }), /*#__PURE__*/_jsx(H4, {
              className: "m-all-0",
              children: /*#__PURE__*/_jsx(UITruncateString, {
                children: headerLabel
              })
            })]
          })
        }), !isUngatedForPatagonia && /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            justify: "between",
            children: [shouldUseResponsiveBreakpoints && showDeviceToggle && /*#__PURE__*/_jsx(BreakpointsContainer, {}), showUndoRedoButtons && /*#__PURE__*/_jsx(UndoRedoButtonContainer, {
              isVisible: true,
              className: "m-left-7",
              disabled: isReadOnlyMode
            })]
          })
        }), isUngatedForPatagonia && /*#__PURE__*/_jsx(UICloseButton, {
          className: "patagonia-sidebar-header-close-button",
          size: "medium",
          onClick: () => closePatagoniaSidebarCallback(),
          "data-selenium": "save-and-close-sidebar"
        })]
      })]
    });
    if (tour) {
      return /*#__PURE__*/_jsx(UITourStep, {
        stepKey: "building",
        showCloseButton: true,
        showSteps: true,
        attachTo: ".sidebar-header",
        placement: "right",
        content: {
          header: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "baymaxShepherd.building.header"
            })
          }),
          body: /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "baymaxShepherd.building.body"
              })
            }), /*#__PURE__*/_jsxs("ul", {
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "baymaxShepherd.building.bodyListItemOneHtml"
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "baymaxShepherd.building.bodyListItemTwoHtml"
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "baymaxShepherd.building.bodyListItemThreeHtml"
                })
              })]
            })]
          }),
          footer: /*#__PURE__*/_jsx(UIButtonWrapper, {
            children: /*#__PURE__*/_jsx(UITourNextButton, {
              use: "primary",
              size: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "baymaxShepherd.next"
              })
            })
          })
        },
        children: headerContainerContents
      });
    }
    return headerContainerContents;
  }
}
BaymaxSidebarHeaderContainer.contextType = TourContext;
BaymaxSidebarHeaderContainer.propTypes = {
  backLink: PropTypes.node,
  headerLabel: PropTypes.node.isRequired,
  showUndoRedoButtons: PropTypes.bool.isRequired,
  shouldUseResponsiveBreakpoints: PropTypes.bool.isRequired,
  showDeviceToggle: PropTypes.bool.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  breadcrumbs: PropTypes.node,
  isUngatedForPatagonia: PropTypes.bool.isRequired,
  closePatagoniaSidebarCallback: PropTypes.func
};
BaymaxSidebarHeaderContainer.defaultProps = {
  showUndoRedoButtons: false
};
export default connect(mapStateToProps)(BaymaxSidebarHeaderContainer);